import React, { useState, useEffect, useRef } from "react";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";

const ActionButton = ({ mainAction, actions, statusColor }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block w-full" ref={dropdownRef}>
      <div className="flex">
        <button
          className={`${statusColor} bg-opacity-70 text-white w-full rounded-l-md hover:bg-opacity-100 px-4 py-2`}
          onClick={() =>
            alert(`You have already ${mainAction.label}ed this candidate`)
          }
        >
          {mainAction.label}
        </button>

        <button
          className={`${statusColor} bg-opacity-70 text-white px-2 py-2 rounded-r-md hover:bg-opacity-100`}
          onClick={() => setDropdownVisible(!dropdownVisible)}
        >
          {!dropdownVisible ? <AiFillCaretDown /> : <AiFillCaretUp />}
        </button>
      </div>

      {dropdownVisible && (
        <div className="absolute left-0 mt-2 w-full bg-white border border-gray-300 rounded-md shadow-lg z-10">
          {actions.map((action, index) => (
            <div
              key={index}
              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                action.label === "Shortlist" ? "text-blue-500" : "text-red-500"
              }`}
              onClick={() => {
                action.onClick();
                setDropdownVisible(false);
              }}
            >
              {action.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const ActionButton1 = ({ mainAction, actions, padding }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null); // Use ref to track dropdown

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  // Close the dropdown if clicked outside
  useEffect(() => {
    console.log(mainAction, "padding");
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block w-full" ref={dropdownRef}>
      <div className="flex">
        <button
          className={`${
            mainAction.label === "Hire"
              ? "bg-green-600"
              : mainAction.label === "Shortlist"
              ? "bg-orange-400"
              : mainAction.label === "Reject"
              ? "bg-red-500"
              : mainAction.label === "Pending"
              ? "bg-yellow cursor-default"
              : "bg-yellow cursor-default"
          } bg-opacity-70 text-white  w-full rounded-l-md hover:bg-opacity-80 ${
            dropdownVisible ? "" : ""
          }
        px-4 `}
          onClick={() => {
            // if (mainAction.label === mainAction.label) {
            //   // mainAction.onClick();
            //   alert(
            //     "you have already " + mainAction.label + "ed this candidate"
            //   );
            // } else {
            if (mainAction.onClick) {
              mainAction.onClick();
            }
            // }
          }}
        >
          {mainAction.label}
        </button>

        <button
          className={`${
            mainAction.label === "Hire"
              ? "bg-green-500"
              : mainAction.label === "Shortlist"
              ? "bg-orange-400"
              : mainAction.label === "Reject"
              ? "bg-red-500"
              : mainAction.label === "Pending"
              ? "bg-yellowcursor-default"
              : "bg-yellow"
          } bg-opacity-70 text-white px-2 py-2 rounded-r-md hover:bg-opacity-100
         `}
          onClick={toggleDropdown}
        >
          {!dropdownVisible ? <AiFillCaretDown /> : <AiFillCaretUp />}
        </button>
      </div>

      {/* Dropdown menu */}
      {dropdownVisible && (
        <div className="absolute left-0 mt-2 w-full bg-white border border-gray-300 rounded-md shadow-lg z-10">
          {actions.map((action, index) => (
            <div
              key={index}
              className={`flex items-center ${
                action.label === "Hire"
                  ? "text-green-500"
                  : action.label === "Shortlist"
                  ? "text-orange-400"
                  : "text-red-500"
              } px-4 py-2 hover:bg-gray-100 cursor-pointer w-full`}
              onClick={() => {
                action.onClick();
                setDropdownVisible(false); // Close dropdown on item click
              }}
            >
              {action.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default function HireDropDown({
  main,
  statusColor,
  handleShortlist,
  handleReject,
}) {
  const mainAction = {
    label: main,
    onClick:
      main === "Shortlisted"
        ? handleShortlist
        : main === "Rejected"
        ? handleReject
        : null,
  };

  const actions = [
    { label: "Shortlist", onClick: handleShortlist },
    { label: "Reject", onClick: handleReject },
  ];

  return (
    <div>
      <ActionButton
        mainAction={mainAction}
        actions={actions}
        statusColor={statusColor}
      />
    </div>
  );
}

export function HireDropDown1(props) {
  const mainAction =
    props.main === 1
      ? { label: "Shortlist", onClick: props.handleShortlist }
      : props.main === 2
      ? { label: "Reject", onClick: props.handleReject }
      : props.main === 3
      ? { label: "Hire", onClick: props.handleHire }
      : props.main === 4
      ? { label: "Proxy", onClick: props.handleProxy }
      : props.main === 0
      ? { label: "Hold", onClick: null }
      : { label: "Pending", onClick: null };

  const actions = props.interview
    ? [
        { label: "Reject", onClick: props.handleReject },
        { label: "Shortlist", onClick: props.handleShortlist },
        { label: "Proxy", onClick: props.handleProxy },
      ]
    : [
        props.main !== 0 && { label: "Hold", onClick: props.handleHold },
        ,
        { label: "Hire", onClick: props.handleHire },
        { label: "Reject", onClick: props.handleReject },
        { label: "Proxy", onClick: props.handleProxy },
        { label: "Shortlist", onClick: props.handleShortlist },
      ];

  return (
    <div className="">
      <ActionButton1
        mainAction={mainAction}
        actions={actions}
        padding={props.padding ?? props.padding}
      />
    </div>
  );
}
